export default __webpack_public_path__ + "static/media/skipping-rope.0acab28d.svg";